export const subscriptionTranslations = {
  save_subscription_success: 8774,
  subscriptions_section_title: 8779,
  subscriptions_section_disclaimer: 8780,
  subscription_tiles_content: 8793,
  subscribe_button: 8806,
  unsubscribe_button: 8807,
  subscribed_text: 8808,
  unsubscribed_text: 8809,
  unassign_cases_action_title: 8832,
  unassign_cases_action_disclaimer: 8833,
  responsible_for_unit_title: 8836,
  alerts_title: 8851,
  alert_disclaimer: 8919,

  add: 5783,
  remove: 5913,
  remove_all_section: 8435,
  save: 8224,
  cancel_changes: 7558,
  are_you_sure: 8218,
  undo_all: 8217,
  go_back: 8219,
  no_options_found: 8220,
  main_title: 8221,
  field: 8018,
  code_table: 8019,

  validation_error: 8206,
  email_invalid: 7758,
  must_be_equal: 7681,
  must_be_filled: 5949,
  must_be_unique: 8105,
  contact_administrator_info: 8830,
  done: 8288,
  cancel: 7956,

  not_selected: 8236,
  add_default_value_disclaimer: 8275,
  default_value_already_set: 8237,
  search_required_message: 8146,

  no_additional_info_has_been_added: 8100,
  no_fields_available: 8399,
  no_options: 8798,
  no_subscriptions: 8819,
  no_responsible_for_unit: 8831,
  no_email: 8838,

  select_all: 8420,
  clear_all: 8421
};

export type SubscriptionTranslations = {
  readonly [T in keyof typeof subscriptionTranslations]: string
};

export const subscriptionsFormName = 'subscriptions';
export const responsibleForUnitFormName = 'responsibleForUnit';
export const alertsFormName = 'alerts';
export const subscriptionSectionId = 'subscriptions-paper';
export const noContentSectionId = 'user-no-content-paper';
